// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"_2dpu0S_A","wrapper":"q2ACnhCV"};